module.exports = __webpack_public_path__ + "static/wind-plant-9bb7fbd5290ef72e2c6f23c5cd7561d6.png";